<a class="skip-link" href="#main">Salta al contenuto</a>

<header class="masthead" role="banner">
  <div class="container masthead-row">
    <a routerLink="/home" class="brand" aria-label="Just Play Bologna — torna alla home">
      <img class="brand-mark" src="assets/jp_icon.png" alt="" width="56" height="56" decoding="async">
      <span class="brand-text">
        <span class="brand-name">Just Play Bologna</span>
        <span class="brand-tag">Ludoteca · Casa del Popolo · Corticella</span>
      </span>
    </a>

    <div class="masthead-end">
      <nav class="masthead-social" aria-label="I nostri canali social">
        <a href="https://www.facebook.com/justplaybologna" target="_blank" rel="noopener" aria-label="Facebook">
          <mat-icon svgIcon="facebook"></mat-icon>
        </a>
        <a href="https://www.instagram.com/justplaybologna/" target="_blank" rel="noopener" aria-label="Instagram">
          <mat-icon svgIcon="instagram"></mat-icon>
        </a>
        <a href="https://t.me/justplaybologna" target="_blank" rel="noopener" aria-label="Telegram">
          <mat-icon svgIcon="telegram"></mat-icon>
        </a>
        <a href="https://www.youtube.com/channel/UCNa0SvpXTR_AJ7Tr32N53TQ" target="_blank" rel="noopener" aria-label="YouTube">
          <mat-icon svgIcon="youtube"></mat-icon>
        </a>
        @if (!isSmallScreen) {
          <a href="https://github.com/JustPlayBo" target="_blank" rel="noopener" aria-label="GitHub">
            <mat-icon svgIcon="github"></mat-icon>
          </a>
          <a href="https://steamcommunity.com/groups/justplaybo" target="_blank" rel="noopener" aria-label="Steam">
            <mat-icon svgIcon="steam"></mat-icon>
          </a>
          <a href="https://discord.gg/89R5hpM" target="_blank" rel="noopener" aria-label="Discord">
            <mat-icon svgIcon="discord"></mat-icon>
          </a>
        }
      </nav>

      <button
        type="button"
        class="theme-toggle"
        (click)="toggleTheme()"
        [attr.aria-label]="theme === 'dark' ? 'Passa al tema chiaro' : 'Passa al tema scuro'"
        [attr.aria-pressed]="theme === 'dark'"
        title="Cambia tema">
        @if (theme === 'dark') {
          <mat-icon svgIcon="weather-sunny"></mat-icon>
        } @else {
          <mat-icon svgIcon="weather-night"></mat-icon>
        }
      </button>
    </div>
  </div>

  <div class="container">
    <svg class="masthead-rule" viewBox="0 0 1000 12" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <path d="M0 4 Q 250 3.2, 500 4.1 T 1000 3.7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <path d="M0 9 Q 250 9.6, 500 8.7 T 1000 9.3" fill="none" stroke="currentColor" stroke-width="0.7" stroke-linecap="round" opacity="0.55"/>
    </svg>
  </div>

  <div class="container masthead-nav-row">
    <nav class="primary-nav" aria-label="Navigazione principale">
      <ul>
        <li><a routerLink="/home" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}">home</a></li>
        <li><a routerLink="/list" routerLinkActive="is-active">i nostri giochi</a></li>
        <li><a routerLink="/faq" routerLinkActive="is-active">faq</a></li>
        @if (!isSmallScreen) {
          <li><a href="https://sherlock.justplaybo.it" target="_blank" rel="noopener">sherlock holmes <span class="extlink" aria-hidden="true">↗</span></a></li>
          <li><a href="https://justplaybo.github.io/launcher/" target="_blank" rel="noopener">launcher <span class="extlink" aria-hidden="true">↗</span></a></li>
          <li><a href="https://chwazi.justplaybo.it" target="_blank" rel="noopener">chwazi <span class="extlink" aria-hidden="true">↗</span></a></li>
        }
      </ul>
    </nav>

    <a routerLink="/support" class="sostienici-cta">
      <span>Sostienici</span>
      <span class="sostienici-arrow" aria-hidden="true">→</span>
    </a>
  </div>
</header>

<main id="main" class="page" role="main">
  <router-outlet></router-outlet>
</main>
